var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactUs = function SvgContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{stroke:#171926;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23836 -22484)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23836 22484)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23833 -22481)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25,16.919a8.1,8.1,0,0,0-5.918-7.787A9.546,9.546,0,1,0,1.324,14.4L.035,19.057l4.659-1.288a9.51,9.51,0,0,0,4.438,1.314,8.084,8.084,0,0,0,11.9,4.795l3.934,1.088-1.088-3.934A8.052,8.052,0,0,0,25,16.919ZM4.925,16.184l-2.789.772.772-2.789-.176-.275A8.078,8.078,0,1,1,5.2,16.36Zm17.939,6.68-2.069-.573-.276.18a6.619,6.619,0,0,1-9.872-3.443,9.564,9.564,0,0,0,8.382-8.382,6.619,6.619,0,0,1,3.443,9.872l-.18.276Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M180.5,271h1.465v1.465H180.5Zm0,0",
    transform: "translate(-171.687 -257.768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M139.895,92.93a1.45,1.45,0,0,1-.477,1.081l-1.72,1.575v1.787h1.465V96.231l1.245-1.139A2.93,2.93,0,1,0,135.5,92.93h1.465a1.465,1.465,0,0,1,2.93,0Zm0,0",
    transform: "translate(-128.884 -85.606)"
  })))));
};
export default SvgContactUs;